import React from "react";

import infiniteLogoBG from "../../assets/images/infiniteBG404.png";

import { useRegisterInterestFormik } from "./useRegisterInterestFormik";
import { useInView } from "react-intersection-observer";
import cs from "classnames";

import "./RegisterInterest.scss";

const RegisterInterest = () => {
  const { ref: backgroundRef, inView: backgroundVisibility } = useInView();
  const { ref: titleRef, inView: titleVisibility } = useInView();
  const { ref: subTitleRef, inView: subTitleVisibility } = useInView();
  const { ref: formRef, inView: formVisibility } = useInView();
  const { ref: buttonRef, inView: buttonVisibility } = useInView();

  const formik = useRegisterInterestFormik({
    onSubmit: (values: any) => {
      console.log("Val:", values);
    },
  });

  return (
    <div className="RegisterInterest">
      <img
        ref={backgroundRef}
        className={cs(
          "RegisterInterest__background",
          backgroundVisibility && "RegisterInterest__background-animation",
        )}
        src={infiniteLogoBG}
      />
      <div className="RegisterInterest__container">
        <div
          ref={titleRef}
          className={cs(
            "RegisterInterest__title",
            titleVisibility && "RegisterInterest__title-animation",
          )}
        >
          Discover Exclusive Access
          <br /> Experience our latest innovations..
        </div>

        <div
          ref={subTitleRef}
          className={cs(
            "RegisterInterest__subtitle",
            subTitleVisibility && "RegisterInterest__subtitle-animation",
          )}
        >
          Join us by registering now and stay connected with our cutting-edge
          advancements.
        </div>

        <form className="RegisterInterest__form" onSubmit={formik.handleSubmit}>
          <div
            ref={formRef}
            className={cs(
              "RegisterInterest__form-container",
              formVisibility && "RegisterInterest__form-container-animation",
            )}
          >
            <div className="RegisterInterest__input-container">
              <div className="RegisterInterest__input-label">First Name</div>
              <input
                className="RegisterInterest__input"
                placeholder="John"
                type="text"
                name="first_name"
                value={formik.values.first_name}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              {formik.errors.first_name && formik.touched.first_name && (
                <div className="RegisterInterest__input-error">
                  {formik.errors.first_name as string}
                </div>
              )}
            </div>
            <div className="RegisterInterest__input-container">
              <div className="RegisterInterest__input-label">Last Name</div>
              <input
                className="RegisterInterest__input"
                placeholder="Smith"
                type="text"
                name="last_name"
                value={formik.values.last_name}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              {formik.errors.last_name && formik.touched.last_name && (
                <div className="RegisterInterest__input-error">
                  {formik.errors.last_name as string}
                </div>
              )}
            </div>
            <div className="RegisterInterest__input-container">
              <div className="RegisterInterest__input-label">Email</div>
              <input
                className="RegisterInterest__input"
                placeholder="johnsmith@example.com"
                type="email"
                name="email"
                value={formik.values.email}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              {formik.errors.email && formik.touched.email && (
                <div className="RegisterInterest__input-error">
                  {formik.errors.email as string}
                </div>
              )}
            </div>
            <div className="RegisterInterest__input-container">
              <div className="RegisterInterest__input-label">
                Company Name ( Optional )
              </div>
              <input
                className="RegisterInterest__input"
                placeholder="Company Name"
                type="text"
                name="company_name"
                value={formik.values.company_name}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              {formik.errors.company_name && formik.touched.company_name && (
                <div className="RegisterInterest__input-error">
                  {formik.errors.company_name as string}
                </div>
              )}
            </div>
            <div className="RegisterInterest__input-container">
              <div className="RegisterInterest__input-label">Industry</div>
              <input
                className="RegisterInterest__input"
                placeholder="Industry Name"
                type="text"
                name="industry"
                value={formik.values.industry}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              {formik.errors.industry && formik.touched.industry && (
                <div className="RegisterInterest__input-error">
                  {formik.errors.industry as string}
                </div>
              )}
            </div>
            <div className="RegisterInterest__input-container">
              <div className="RegisterInterest__input-label">Country</div>
              <input
                className="RegisterInterest__input"
                placeholder="Afganistan"
                type="text"
                name="country"
                value={formik.values.country}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              {formik.errors.country && formik.touched.country && (
                <div className="RegisterInterest__input-error">
                  {formik.errors.country as string}
                </div>
              )}
            </div>
          </div>

          <div ref={buttonRef} className="RegisterInterest__button-container">
            <div
              className={cs(
                "RegisterInterest__button-outside",
                buttonVisibility &&
                  "RegisterInterest__button-outside-animation",
              )}
            >
              <div
                className={cs(
                  "RegisterInterest__button-middle",
                  buttonVisibility &&
                    "RegisterInterest__button-middle-animation",
                )}
              >
                <div
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                  className="RegisterInterest__button"
                >
                  Register
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterInterest;
